import { type CallbackInterface } from 'recoil'

import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'

import {
  getWorkflow,
  setEnableWorkflow
} from 'Pages/WorkflowsList/recoil/actions/actions'
import { modalActivateSimulateState } from 'Pages/WorkflowsList/recoil/state/modalActivateSimulate'
import { pageState } from 'Pages/WorkflowsList/recoil/state/page'
import { toggleStatusState } from 'Pages/WorkflowsList/recoil/state/search'

export const modalActivateSimulateCloseCallback =
  ({ reset }: CallbackInterface) =>
  async () => {
    reset(modalActivateSimulateState)
  }

export const modalActivateSimulateActivateCallback =
  ({ set, reset, snapshot }: CallbackInterface) =>
  async () => {
    const { idWorkflow } = await snapshot.getPromise(modalActivateSimulateState)

    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    reset(modalActivateSimulateState)

    try {
      await setEnableWorkflow(idWorkflow, { Enable: true })

      set(toggleStatusState(idWorkflow), (prev) => ({
        ...prev,
        statusToggle: true
      }))

      toastShow(
        getIntl().formatMessage({
          id: 'Load.AutomationWorkflow.SuccessEnable'
        }),
        TOAST_VARIANT_SUCCESS,
        'simulateAsyncTaskCallbackKO'
      )
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'WorkflowsList',
        Method: 'modalActivateSimulateActivateCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }

export const modalActivateSimulateSimulateOpenCallback =
  ({ set }: CallbackInterface) =>
  async (idWorkflow: number) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))

    try {
      const wf = await getWorkflow(idWorkflow)

      set(modalActivateSimulateState, {
        idWorkflow,
        mode: 'simulate',
        show: true,
        recipientLimit: wf.RecipientLimit ?? 0
      })
    } catch (error) {
      console.error('### error', error)

      logAppError({
        Component: 'WorkflowsList',
        Method: 'modalActivateSimulateSimulateOpenCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))
  }
